export default "__VITE_ASSET__4ET5GL_M__"